import { render, staticRenderFns } from "./TwoPhaseMethodSetting.vue?vue&type=template&id=579eee5b&scoped=true"
import script from "./TwoPhaseMethodSetting.vue?vue&type=script&lang=js"
export * from "./TwoPhaseMethodSetting.vue?vue&type=script&lang=js"
import style0 from "./TwoPhaseMethodSetting.vue?vue&type=style&index=0&id=579eee5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579eee5b",
  null
  
)

export default component.exports